import styled from 'styled-components';
import photo1 from 'assets/images/photo1.jpg';
import photoMobile1 from 'assets/images/photo-mobile1.jpg';
import { fonts } from 'styles';

export const Container = styled.header`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 124px 0 112px 0;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1024px;
  margin-bottom: 80px;
  color: #000;

  @media screen and (max-width: 1024px) {
    padding: 0 32px;
    margin-bottom: 48px;
  }
`;

export const Title = styled.h1`
  font-size: 60px;
  line-height: 60px;
  letter-spacing: -2px;
  margin-bottom: 48px;
  text-transform: uppercase;

  @media screen and (max-width: 500px) {
    font-size: 28px;
    line-height: 30px;
    letter-spacing: -1px;
    margin-bottom: 24px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  column-gap: 48px;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
    row-gap: 40px;
  }
`;

export const Text = styled.article`
  font-size: 16px;
  line-height: 20px;
  width: 100%;
  max-width: 500px;

  @media screen and (max-width: 500px) {
    br {
      display: none;
    }
  }
`;

export const Credits = styled.div`
  font-size: 13px;
  line-height: 17px;
  text-transform: uppercase;

  span {
    font-family: ${fonts.BentonSansBold};
  }

  @media screen and (max-width: 1024px) {
    padding-top: 32px;
    border-top: 1px solid #000;
  }
`;

export const Photo1 = styled.img.attrs({ src: photo1 })`
  width: 100%;
  margin-bottom: 24px;

  @media screen and (max-width: 500px) {
    display: none;
  }
`;

export const PhotoMobile1 = styled.img.attrs({ src: photoMobile1 })`
  display: none;
  width: 100%;
  margin-bottom: 24px;

  @media screen and (max-width: 500px) {
    display: block;
  }
`;

export const Legend = styled.div`
  width: 100%;
  text-align: center;
  max-width: 810px;
  font-size: 14px;
  line-height: 20px;

  @media screen and (max-width: 1024px) {
    padding: 0 32px;
    text-align: left;
  }
`;
